import React from 'react';
import { Row, Col } from 'react-bootstrap';

function OnlyInformation({
  title = '',
  subtitle = '',
  subtitle2 = '',
  GeneralColor = '',
  onRequest = false,
  fontSizeSubtitle = '',
  labelColor = ''
}) {
  const styling = {
    stroke: GeneralColor,
    strokeDasharray: `${101} 100`,
    animationName: 'Fill', // Nombre del keyframe
    animationDuration: '2s', // Duración de la animación
    animationTimingFunction: 'linear',
    animationIterationCount: 'forwards'
  };

  return (
    <>
      {!onRequest && (
        <Row style={{ alignItems: 'center' }}>
          {title !== '' && (
            <Col md={4} xs={4} xl={4}>
              <div className="Percentage">
                <svg width="100" height="100">
                  <circle className="circle" r="30%" cx="50%" cy="50%" pathLength="100" style={{ stroke: '#adadad' }} />
                  <circle className="circle" r="30%" cx="50%" cy="50%" pathLength="100" style={styling} />
                </svg>
                <span style={{ color: '#000', alignSelf: 'center', fontSize: 20 }}>{title}</span>
              </div>
            </Col>
          )}
          <Col xs={8} md={8} xl={8}>
            {subtitle2 && (
              <p style={{ fontSize: fontSizeSubtitle, fontWeight: 'bold', color: 'black', marginLeft: '-6px' }}>
                {subtitle2}
              </p>
            )}
            <p style={{ fontSize: '11px', fontWeight: 'bold', color: labelColor || 'black' }}>{subtitle}</p>
          </Col>
        </Row>
      )}
    </>
  );
}

export default OnlyInformation;
